var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "22px",
    width: "22px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 612.00 612.00",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M577.661,612H34.339c-10.358,0-18.751-8.396-18.751-18.751V18.751C15.588,8.396,23.98,0,34.339,0h543.322 c10.355,0,18.751,8.396,18.751,18.751v574.497C596.412,603.604,588.016,612,577.661,612z M53.09,574.497h505.82V37.502H53.09 V574.497z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.951,157.596H135.047c-10.355,0-18.751-8.393-18.751-18.751c0-10.355,8.396-18.751,18.751-18.751h341.905 c10.355,0,18.751,8.396,18.751,18.751C495.702,149.204,487.307,157.596,476.951,157.596z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.951,269.033H135.047c-10.355,0-18.751-8.393-18.751-18.751c0-10.355,8.396-18.751,18.751-18.751h341.905 c10.355,0,18.751,8.396,18.751,18.751C495.702,260.641,487.307,269.033,476.951,269.033z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.951,380.469H135.047c-10.355,0-18.751-8.393-18.751-18.751c0-10.355,8.396-18.751,18.751-18.751h341.905 c10.355,0,18.751,8.396,18.751,18.751C495.702,372.076,487.307,380.469,476.951,380.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278.154,491.906H135.047c-10.355,0-18.751-8.394-18.751-18.751c0-10.355,8.396-18.751,18.751-18.751h143.106 c10.355,0,18.751,8.396,18.751,18.751C296.905,483.512,288.509,491.906,278.154,491.906z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.8bf11a878944d0e856b1faf120d36d01.svg";
export { ForwardRef as ReactComponent };